import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import ActionBar from '../actionBar';
import GenerateInviteDialog from './GenerateInviteDialog';
import RegistrationTable from './RegistrationTable';
import HttpService from '../../backend/requestApis';
import { fetchInvites } from '../../backend/backendApis';
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import RegistrationTiles from './RegistrationTiles';

const RegistrationHub = () => {
  const [generateInviteDialog, setGenerateInviteDialog] = useState(false);
  
  const navigate = useNavigate();
  // Table state with a default offset of 10
  const [page, setPage] = useState(1);
  const [offset, setOffset] = useState(10);
  const [filterBy, setFilterBy] = useState('');
  const [filterOn, setFilterOn] = useState('Filter On');
  const [sortColumn, setSortColumn] = useState('name');
  const [sortOrder, setSortOrder] = useState(1);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [data, setData] = useState({ records: [], totalRecords: 0, totalPages: 1 });
  const [isLoading, setIsLoading] = useState(false);

  const [selectedTile, setSelectedTile] = useState("total");

  useEffect(() => {
    const getInvites = async () => {
      try {
        setIsLoading(true);
        let options = {
          url: fetchInvites,
          method: 'GET',
          params: {
            page: page,
            offset: offset,
            ...(selectedTile !== "total" && { status: selectedTile })
          },
          headers: {
            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
          }
        };
        let response = await HttpService(options);
        if (response?.data?.status === 1 || response?.data?.data) {
          setData(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching invites:', error);
        if (error?.response?.status === 403 || error?.status === 403) {
          localStorage.clear();
          window.location.href = '/Login';
          return;
        }
      } finally {
        setIsLoading(false);
      }
    };
    getInvites();
  }, [page, offset, refreshTrigger,selectedTile]);

  const updatePage = (newPage) => {
    setPage(newPage);
  };

  const updateOffset = (newOffset) => {
    setPage(1);
    setOffset(newOffset);
  };

  const updateFilterBy = (val) => {
    setFilterBy(val);
    setPage(1);
  };

  const updateFilterOn = (val) => {
    setFilterOn(val);
  };

  const updateSort = (column, order) => {
    setSortColumn(column);
    setSortOrder(order);
    setPage(1);
  }

  return (
    <>
      <ActionBar dashBoard="registrationHub" onGenerateInvite={() => setGenerateInviteDialog(true)} />
      <Box sx={{ p: 2 }}>
        {isLoading && <Loader />}
        {/* Registration Hub content goes here */}

        <Box>
          <RegistrationTiles 
                    selectedTile={selectedTile}
                    setSelectedTile={setSelectedTile} />
        </Box>

      <Box sx={{ p: 1 }}>
        <RegistrationTable
            data={data} 
            pageValue={page}
            updatePage={updatePage}
            offsetValue={offset}
            updateOffset={updateOffset}
            filterByValue={filterBy}
            updateFilterBy={updateFilterBy}
            filterOnValue={filterOn}
            updateFilterOn={updateFilterOn}
            updateSort={updateSort}
            onRefresh={() => setRefreshTrigger(prev => prev + 1)}
        />
      </Box>
      <GenerateInviteDialog
        dialogStatus={generateInviteDialog}
        updateDialogStatus={(status, refresh) => {
          setGenerateInviteDialog(status);
          if (refresh) setRefreshTrigger(prev => prev + 1);
        }}
      />
      </Box>
    </>
  )
}

export default RegistrationHub
